import React, { useState } from 'react';

import { TpAutoFormChoice } from './AutoForm';
import styles from './AutoForm.module.scss';

interface TpSearchInputFieldProps {
  id: string;
  onUpdate: (option: string) => void;
  fieldOptions: TpAutoFormChoice[];
}

export function SearchInputField({ id, onUpdate, fieldOptions }: TpSearchInputFieldProps) {
  const [filteredOptions, setFilteredOptions] = useState<TpAutoFormChoice[]>([]);
  const [inputValue, setInputValue] = useState<string>('');
  const [startedSearch, setStartedSearch] = useState<boolean>(false);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setStartedSearch(true);
    const value = event.target.value;
    setInputValue(value);
    const filtered = fieldOptions
      .filter((option) => option.content.toLowerCase().includes(value.toLowerCase()))
      .splice(0, 4);
    setFilteredOptions(filtered);
  };

  const handleOptionSelect = (option: TpAutoFormChoice) => {
    setInputValue(option.content);
    onUpdate(option.id);
    setFilteredOptions([]);
    setStartedSearch(false);
  };

  return (
    <div className={styles.searchInput}>
      <input
        id={id}
        value={inputValue}
        onChange={handleInputChange}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            handleOptionSelect(filteredOptions[0]);
          }
        }}
      />

      <ul className={styles.searchInputMenu}>
        {filteredOptions.length > 0 ? (
          filteredOptions.map((option, index) => (
            <li className={styles.searchInputMenuItem} key={option.id} onClick={() => handleOptionSelect(option)}>
              {option.content}
            </li>
          ))
        ) : startedSearch ? (
          <li className={styles.searchInputMenuItem}> No items found</li>
        ) : null}
      </ul>
    </div>
  );
}
